<script>
	import { setLanguage, setTranslations } from './language'
	import { setColors } from './colors'

	import Chart01 from './charts/01_destruction_before_after/01_destruction_before_after.svelte'
	import Chart02 from './charts/02_static_annotated_map/02_static_annotated_map.svelte'

	export let graphicId

	// FIXME: this is a bit hacky. [David]
	// TODO: add to docs
	// assuming graphic_ids of the form
	// 01_mariupol__map (--> case_id=mariupol)
	// or if there are multiple maps:
	// 01_mariupol__map_1 (--> case_id=mariupol1)
	// the before after chart type has id
	// 01_mariupol__slider (oder __slider_1)
	let [part1, part2] = graphicId.split('__')
	let chartType = part2.split('_')[0]
	let city = part1.split('_')[1]
	let num = part2.split('_')[1] || ''
	// using the weird structure because we can't use dynamic imports or import another js file
	const charts = {
		slider: Chart01,
		map: Chart02
	}

	let chartComponent = charts[chartType]
	let caseId = city + num
	console.log(graphicId, chartType, chartComponent, caseId)

	const setOptions = (params) => {
		if (params.language) setLanguage(params.language)
		if (params.translations) setTranslations(params.translations)
		if (params.colors) setColors(params.colors)
	}

	setOptions($$props)
</script>

<svelte:component this={chartComponent} {caseId} {...$$props} />
